// redux/Countries/reducer.js
import {
    FETCH_COUNTRIES_SUCCESS,
    FETCH_COUNTRIES_FAILURE,
    FETCH_COUNTRY_SUCCESS,
    FETCH_COUNTRY_FAILURE,
    CREATE_COUNTRY_SUCCESS,
    CREATE_COUNTRY_FAILURE,
    UPDATE_COUNTRY_SUCCESS,
    UPDATE_COUNTRY_FAILURE,
    DELETE_COUNTRY_SUCCESS,
    DELETE_COUNTRY_FAILURE,
  } from './types';
  
  const initialState = {
    countries: [],
    country: null,
    error: '',
  };
  
  export function countriesReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_COUNTRIES_SUCCESS:
        return {
          ...state,
          countries: action.payload,
          error: '',
        };
      case FETCH_COUNTRIES_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case FETCH_COUNTRY_SUCCESS:
        return {
          ...state,
          country: action.payload,
          error: '',
        };
      case FETCH_COUNTRY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case CREATE_COUNTRY_SUCCESS:
        return {
          ...state,
          countries: [...state.countries, action.payload],
          error: '',
        };
      case CREATE_COUNTRY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case UPDATE_COUNTRY_SUCCESS:
        return {
          ...state,
          countries: state.countries.map((country) =>
            country._id === action.payload._id ? action.payload : country
          ),
          error: '',
        };
      case UPDATE_COUNTRY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case DELETE_COUNTRY_SUCCESS:
        return {
          ...state,
          countries: state.countries.filter((country) => country._id !== action.payload),
          error: '',
        };
      case DELETE_COUNTRY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      default:
        return state;
    }
  }
  